"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfBankAccountCreateDto = instanceOfBankAccountCreateDto;
exports.BankAccountCreateDtoFromJSON = BankAccountCreateDtoFromJSON;
exports.BankAccountCreateDtoFromJSONTyped = BankAccountCreateDtoFromJSONTyped;
exports.BankAccountCreateDtoToJSON = BankAccountCreateDtoToJSON;
exports.BankAccountCreateDtoToJSONTyped = BankAccountCreateDtoToJSONTyped;
/**
 * Check if a given object implements the BankAccountCreateDto interface.
 */
function instanceOfBankAccountCreateDto(value) {
    if (!('accountName' in value) || value['accountName'] === undefined)
        return false;
    if (!('bsb' in value) || value['bsb'] === undefined)
        return false;
    if (!('accountNumber' in value) || value['accountNumber'] === undefined)
        return false;
    if (!('bankName' in value) || value['bankName'] === undefined)
        return false;
    return true;
}
function BankAccountCreateDtoFromJSON(json) {
    return BankAccountCreateDtoFromJSONTyped(json, false);
}
function BankAccountCreateDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'accountName': json['accountName'],
        'bsb': json['bsb'],
        'accountNumber': json['accountNumber'],
        'bankName': json['bankName'],
    };
}
function BankAccountCreateDtoToJSON(json) {
    return BankAccountCreateDtoToJSONTyped(json, false);
}
function BankAccountCreateDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'accountName': value['accountName'],
        'bsb': value['bsb'],
        'accountNumber': value['accountNumber'],
        'bankName': value['bankName'],
    };
}
